var map = {
	"./Vectorillus1": 16,
	"./Vectorillus1.png": 16,
	"./airtel": 17,
	"./airtel-money1": 18,
	"./airtel-money1.png": 18,
	"./airtel.png": 17,
	"./al-izza": 19,
	"./al-izza-grey": 20,
	"./al-izza-grey.png": 20,
	"./al-izza.png": 19,
	"./alizza": 10,
	"./alizza-square": 21,
	"./alizza-square.png": 21,
	"./alizza.jpg": 302,
	"./alizza.png": 10,
	"./amanata": 22,
	"./amanata.png": 22,
	"./amicoboutiq": 23,
	"./amicoboutiq.svg": 23,
	"./ansi": 24,
	"./ansi.png": 24,
	"./benin": 25,
	"./benin.png": 25,
	"./bg-cover": 26,
	"./bg-cover.png": 26,
	"./boa-icon": 27,
	"./boa-icon.png": 27,
	"./checkmark": 28,
	"./checkmark-white": 29,
	"./checkmark-white.svg": 29,
	"./checkmark.svg": 28,
	"./chevron-down": 30,
	"./chevron-down.svg": 30,
	"./chevron-up": 31,
	"./chevron-up.svg": 31,
	"./cip": 11,
	"./cip.jpg": 303,
	"./cip.png": 11,
	"./circle-scatter": 32,
	"./circle-scatter.svg": 32,
	"./default-avatar": 33,
	"./default-avatar.png": 33,
	"./default-image": 34,
	"./default-image.png": 34,
	"./ecobank": 12,
	"./ecobank.jpg": 304,
	"./ecobank.png": 12,
	"./ecobanq": 35,
	"./ecobanq.png": 35,
	"./ecobanqc": 36,
	"./ecobanqc.png": 36,
	"./fa-envelope": 37,
	"./fa-envelope.png": 37,
	"./fa-phone": 38,
	"./fa-phone.png": 38,
	"./facebook": 39,
	"./facebook.png": 39,
	"./flutter": 40,
	"./flutter-white": 41,
	"./flutter-white.png": 41,
	"./flutter.png": 40,
	"./group2": 42,
	"./group2.svg": 42,
	"./grouplink": 43,
	"./grouplink.png": 43,
	"./ifutur": 44,
	"./ifutur-matrix": 45,
	"./ifutur-matrix.png": 45,
	"./ifutur.png": 44,
	"./ifuturhommefemme": 46,
	"./ifuturhommefemme.png": 46,
	"./image3": 47,
	"./image3.png": 47,
	"./ipaymoney1": 48,
	"./ipaymoney1.svg": 48,
	"./javascript-white": 49,
	"./javascript-white.png": 49,
	"./line": 50,
	"./line.png": 50,
	"./linkedin": 51,
	"./linkedin.png": 51,
	"./logo": 52,
	"./logo-ansi": 53,
	"./logo-ansi.png": 53,
	"./logo-nita": 54,
	"./logo-nita.png": 54,
	"./logo-obn": 55,
	"./logo-obn.png": 55,
	"./logo-white": 56,
	"./logo-white.png": 56,
	"./logo.png": 52,
	"./logo_alizza": 57,
	"./logo_alizza.png": 57,
	"./logoip": 58,
	"./logoip.png": 58,
	"./logoip_blanc": 59,
	"./logoip_blanc.png": 59,
	"./long-page": 60,
	"./long-page.png": 60,
	"./lp-line-separator": 61,
	"./lp-line-separator.png": 61,
	"./lp-phone": 62,
	"./lp-phone.png": 62,
	"./lp-store": 63,
	"./lp-store.png": 63,
	"./lp-tpe": 64,
	"./lp-tpe.png": 64,
	"./map-screenshot": 65,
	"./map-screenshot.png": 65,
	"./mastercard": 13,
	"./mastercard-logo": 66,
	"./mastercard-logo.png": 66,
	"./mastercard.jpg": 305,
	"./mastercard.png": 13,
	"./moov": 67,
	"./moov-money": 68,
	"./moov-money.png": 68,
	"./moov.png": 67,
	"./moovc": 69,
	"./moovc.png": 69,
	"./mtn": 70,
	"./mtn.png": 70,
	"./necs": 71,
	"./necs.jpeg": 71,
	"./niger": 72,
	"./niger.png": 72,
	"./nita": 73,
	"./nita-square": 74,
	"./nita-square.png": 74,
	"./nita.png": 73,
	"./obeecs": 75,
	"./obeecs.png": 75,
	"./obn": 76,
	"./obn.png": 76,
	"./onecs": 77,
	"./onecs.png": 77,
	"./orabank": 14,
	"./orabank.jpg": 306,
	"./orabank.png": 14,
	"./ordi1": 78,
	"./ordi1.png": 78,
	"./ordi2": 79,
	"./ordi2.png": 79,
	"./oxfam": 80,
	"./oxfam.png": 80,
	"./oxfamc": 81,
	"./oxfamc.png": 81,
	"./partners/africa-development-universalis": 82,
	"./partners/africa-development-universalis.png": 82,
	"./partners/airtel": 83,
	"./partners/airtel-1": 84,
	"./partners/airtel-1.png": 84,
	"./partners/airtel.jpeg": 83,
	"./partners/ansi": 85,
	"./partners/ansi.png": 85,
	"./partners/armoiries": 86,
	"./partners/armoiries.png": 86,
	"./partners/banque-mondiale": 87,
	"./partners/banque-mondiale.png": 87,
	"./partners/boa": 88,
	"./partners/boa.png": 88,
	"./partners/eco-xpress": 89,
	"./partners/eco-xpress.png": 89,
	"./partners/helen-keller-int": 90,
	"./partners/helen-keller-int.png": 90,
	"./partners/moov-africa": 91,
	"./partners/moov-africa.jpeg": 91,
	"./partners/mtn": 92,
	"./partners/mtn.png": 92,
	"./partners/necs": 93,
	"./partners/necs.jpeg": 93,
	"./partners/obn": 94,
	"./partners/obn.png": 94,
	"./partners/onep": 95,
	"./partners/onep.png": 95,
	"./partners/orange": 96,
	"./partners/orange.png": 96,
	"./partners/oxfam": 97,
	"./partners/oxfam.png": 97,
	"./partners/pvi": 98,
	"./partners/pvi.png": 98,
	"./partners/snfi": 99,
	"./partners/snfi.png": 99,
	"./partners/snv": 100,
	"./partners/snv.png": 100,
	"./partners/sunu-assurance": 101,
	"./partners/sunu-assurance.png": 101,
	"./partners/swiss-contact": 102,
	"./partners/swiss-contact.png": 102,
	"./partners/uddm": 103,
	"./partners/uddm.png": 103,
	"./partners/uncdf": 104,
	"./partners/uncdf.png": 104,
	"./partners/universite-agadez": 105,
	"./partners/universite-agadez.png": 105,
	"./partners/world-health-organisation": 106,
	"./partners/world-health-organisation.png": 106,
	"./partners/zamani": 107,
	"./partners/zamani-cash": 108,
	"./partners/zamani-cash.png": 108,
	"./partners/zamani.jpeg": 107,
	"./pattern": 109,
	"./pattern.svg": 109,
	"./payment-1": 110,
	"./payment-1.png": 110,
	"./payment-2": 111,
	"./payment-2.png": 111,
	"./payment-3": 112,
	"./payment-3.png": 112,
	"./pcidss": 113,
	"./pcidss-white": 114,
	"./pcidss-white.png": 114,
	"./pcidss.png": 113,
	"./phone-bell": 115,
	"./phone-bell.jpg": 115,
	"./photolive": 116,
	"./photolive.png": 116,
	"./projet-lire": 117,
	"./projet-lire.png": 117,
	"./promotion-1": 118,
	"./promotion-1.png": 118,
	"./rafikicollet": 119,
	"./rafikicollet.svg": 119,
	"./receipt": 120,
	"./receipt.svg": 120,
	"./screenshot": 121,
	"./screenshot.png": 121,
	"./service-1": 122,
	"./service-1.png": 122,
	"./service-2": 123,
	"./service-2.png": 123,
	"./service-3": 124,
	"./service-3.png": 124,
	"./service-4": 125,
	"./service-4.png": 125,
	"./short-page": 126,
	"./short-page.png": 126,
	"./signatureOFF": 127,
	"./signatureOFF.jpg": 127,
	"./signin": 128,
	"./signin.png": 128,
	"./signup": 129,
	"./signup.png": 129,
	"./site1": 130,
	"./site1.png": 130,
	"./solution1": 131,
	"./solution1.svg": 131,
	"./solution2": 132,
	"./solution2.svg": 132,
	"./solution3": 133,
	"./solution3.svg": 133,
	"./success.json": 307,
	"./twiter": 134,
	"./twiter.png": 134,
	"./uncdf": 135,
	"./uncdf-2": 136,
	"./uncdf-2.png": 136,
	"./uncdf.png": 135,
	"./uncdfc": 137,
	"./uncdfc.png": 137,
	"./vectorsol1": 138,
	"./vectorsol1.png": 138,
	"./vectorsol3": 139,
	"./vectorsol3.png": 139,
	"./vectorsol4": 140,
	"./vectorsol4.png": 140,
	"./visa": 141,
	"./visa-2": 142,
	"./visa-2.png": 142,
	"./visa-square": 143,
	"./visa-square.png": 143,
	"./visa.png": 141,
	"./visa1": 144,
	"./visa1.png": 144,
	"./visa_logo": 145,
	"./visa_logo.png": 145,
	"./visa_logo.svg": 146,
	"./visa_logo.svg.png": 146,
	"./welcom-submit": 147,
	"./welcom-submit.png": 147,
	"./whatsapp": 15,
	"./whatsapp copy": 148,
	"./whatsapp copy.svg": 148,
	"./whatsapp.png": 15,
	"./whatsapp.svg": 308,
	"./woo1": 149,
	"./woo1.png": 149,
	"./woo2": 150,
	"./woo2.png": 150,
	"./woo3": 151,
	"./woo3.png": 151,
	"./woocommerce-white": 152,
	"./woocommerce-white.png": 152,
	"./zamani": 153,
	"./zamani-cash": 154,
	"./zamani-cash.png": 154,
	"./zamani.png": 153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 301;